import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPredictionRuleModel from "./AbstractPredictionRuleModel.js";

/**
 * Compute data using the same period from `shift` previous years and
 * a `growthPercentage`.
 *
 * For example, if `shift` equals 1 and forecast starts on January
 * 2022:
 *
 * - January 2022 = January 2021 * (100+`growthPercentage`)/100
 * - February 2022 = February 2021 * (100+`growthPercentage`)/100
 * - …
 *
 * If `shift` equals 2 and forecast starts on January 2022:
 *
 * - January 2022 = (January 2021 + January 2020)/2 * (100+`growthPercentage`)/100
 * - February 2022 = (February 2021 + February 2020)/2 * (100+`growthPercentage`)/100
 * - …
 *
 * @param {number} shift - Number of previous months
 *   to consider for the regression
 * @param {float} growthPercentage - The increase/decrease to compute a
 *   month based on the value of the previous one
 */
export default class FromActualsPredictionRuleModel extends AbstractPredictionRuleModel {
	constructor({ shift = 12, growthPercentage = 0 } = {}) {
		super(...arguments);

		this._shift = shift;
		this._growthPercentage = growthPercentage;
	}

	getShift() {
		return this._shift;
	}

	setShift(shift) {
		this._shift = shift;
	}

	getGrowthPercentage() {
		return this._growthPercentage;
	}

	setGrowthPercentage(growthPercentage) {
		this._growthPercentage = growthPercentage;
	}

	accept(visitor) {
		return visitor.visitFromActualsPredictionRuleModel(this);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.shift = this._shift;
		properties.growthPercentage = this._growthPercentage;

		return properties;
	}

	static getLabel() {
		return _("From actuals");
	}

	static getType() {
		return "FromActuals";
	}

	static getDescriptionText() {
		return _("Forecast based on same period in the past and a growth");
	}
}
